import { useMutation } from '@hooks/reactQuery';

import { revokeAssetByUnit } from '@api/assetsRent';

import { IApprovalActionAssetByUnitDTO } from '@interfaces/rent/dto/assetRentDTO';

import { APPROVAL_UNIT_INFO } from '@constants/queryKeys';

interface IUseMutateDeclineAssetByUnitProps {
	assetId: string;
	isAO: boolean;
	onSuccessCallbacks: Array<() => void>;
}

export const useMutateRevokeAssetByUnit = ({
	assetId,
	isAO,
	onSuccessCallbacks,
}: IUseMutateDeclineAssetByUnitProps) => {
	const { mutate: revokeAssetByApprovalUnit } = useMutation<IApprovalActionAssetByUnitDTO>({
		mutationKey: [APPROVAL_UNIT_INFO, assetId, isAO],
		mutationFn: ({
			approvalUnitId,
			comment,
			itemId,
		}: IApprovalActionAssetByUnitDTO) => {
			return revokeAssetByUnit({
				approvalUnitId,
				comment,
				itemId,
			});
		},
		onSuccess: () => {
			if (onSuccessCallbacks.length) onSuccessCallbacks.forEach((callback) => callback());
		},
	});

	return {
		revokeAssetByApprovalUnit,
	};
};
